import axios from 'axios';
import { getDeviceId } from '../utils/device-info.util';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (url, method, data = null) => {
  const baseAPIUrl = process.env.REACT_APP_CMS_API_ENDPOINT;
  const uuid = getDeviceId();
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);

  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Req-Device': uuid,
      'X-Admin-Auth-Token': adminAuth,
    },
    data: JSON.stringify(data || {}),
  };

  return options;
};


export const createNewShow = async (payload) => {
    const options = prepareRequestOptions(
      '/admin/show/create',
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const viewShowById = async (id) => {
    const options = prepareRequestOptions(`/admin/show/${id}/view`, 'GET');
  
    const response = await axios(options);
    return response.data;
  };
  
  export const updateShowById = async (id, payload) => {
    const options = prepareRequestOptions(
      `/admin/show/${id}/update`,
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const deleteShowById = async (id) => {
    const options = prepareRequestOptions(`/admin/show/${id}/delete`, 'DELETE', null, true);
  
    const response = await axios(options);
    return response.data;
  };
  
  export const getSearchListShow = async (adminUserId) => {
    const options = prepareRequestOptions(
      `/admin/show/search-list/${adminUserId}`,
      'GET'
    );
  
    const response = await axios(options);
    return response.data;
  };

  export const updateShowPodcastSequence = async (payload) => {
    const options = prepareRequestOptions(
      '/admin/sequence/show/update',
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };